'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { ArrowLeft } from '@phosphor-icons/react';
import { HomeIcon } from '@/components/icons';
import { Button } from '@/components/ui/primitives/button';

export default function NotFound() {
  const router = useRouter();

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlBg = html.style.backgroundColor;
    const prevBodyBg = body.style.backgroundColor;

    html.style.backgroundColor = '#15092D';
    body.style.backgroundColor = '#15092D';

    return () => {
      html.style.backgroundColor = prevHtmlBg;
      body.style.backgroundColor = prevBodyBg;
    };
  }, []);

  return (
    <main
      className="h-dvh flex flex-col items-center justify-center px-4 relative overflow-hidden"
      style={{
        backgroundColor: '#15092D',
        background:
          'radial-gradient(ellipse 80% 60% at 50% 40%, rgba(151,106,185,0.3) 0%, rgba(151,106,185,0.1) 35%, #15092D 65%)',
      }}
    >
      {/* Картинка — занимает до 50% высоты экрана, сжимается если не хватает места */}
      <div
        className="relative w-full shrink animate-fade-up"
        style={{ maxHeight: '50dvh', aspectRatio: '1 / 1', maxWidth: '540px' }}
      >
        <Image
          src="https://cdn.aziatochka.ru/aziatochka/404/404.webp"
          alt="404 — страница не найдена"
          fill
          className="object-contain drop-shadow-[0_0_60px_rgba(123,66,255,0.25)]"
          priority
          unoptimized
        />
      </div>

      {/* Текст */}
      <div className="text-center mt-2 space-y-1.5 max-w-md shrink-0 animate-fade-up" style={{ animationDelay: '0.1s' }}>
        <h1 className="text-xl sm:text-3xl md:text-4xl font-heading font-bold text-white">
          Ой, тут пусто
        </h1>
        <p className="text-xs sm:text-base font-body" style={{ color: '#B794FF' }}>
          Похоже, этот ролл укатился куда-то не туда.
          <br className="hidden sm:block" />
          {' '}Но у нас ещё много вкусного — возвращайтесь!
        </p>
      </div>

      {/* Кнопки */}
      <div
        className="flex flex-col sm:flex-row gap-2.5 sm:gap-3 mt-5 w-full max-w-xs sm:max-w-none sm:w-auto shrink-0 animate-fade-up"
        style={{ animationDelay: '0.2s' }}
      >
        <button
          onClick={() => router.back()}
          className="inline-flex items-center justify-center gap-2 h-11 sm:h-12 px-5 sm:px-6 text-sm sm:text-base font-semibold rounded-card transition-all duration-200 active:scale-[0.97] w-full sm:w-auto cursor-pointer"
          style={{
            border: '1.5px solid rgba(123,66,255,0.4)',
            backgroundColor: 'transparent',
            color: '#FFFFFF',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = '#7B42FF';
            e.currentTarget.style.backgroundColor = 'rgba(123,66,255,0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = 'rgba(123,66,255,0.4)';
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          <ArrowLeft weight="bold" className="w-[1.125em] h-[1.125em]" />
          Назад
        </button>
        <Link href="/" className="w-full sm:w-auto">
          <Button
            variant="glow"
            size="xl"
            leftIcon={<HomeIcon weight="bold" />}
            className="w-full"
          >
            На главную
          </Button>
        </Link>
      </div>
    </main>
  );
}
